//Used to check if code is running on client or server
const isClient = typeof window != "undefined";

module.exports = {
  isClient,
};
